<template>
  <div class="sign-info">
    <role-tab :ywtTab="true" />
    <div class="main-wrap">
      <div class="left-wrap">
        <publish-sign
          v-if="
            $store.getters.currentAuthUser.userStemFrom !== -16 || isInDingTalk
          "
          class="publish"
          fileText="发起签署"
          tplText="模板发起签署"
        />
        <div v-else class="dindin_code">
          <img
            src="../../static/images/dindin_code.png"
            class="code_img"
            alt=""
          />
        </div>
        <el-tabs v-model="tabsActive" :stretch="true" class="tabs-style">
          <!-- tabs 1 start -->
          <el-tab-pane label="由我经办的" name="contract">
            <apply-menu-tree
              :defaultExpandedKeys="['changeUserInfo']"
              class="menu-tree"
              ref="menuTree"
              :currentMenuName.sync="currentMenuName"
              :initCallback="initMenuTree"
              :menus="menus"
            />
          </el-tab-pane>
          <!-- tabs 1 end -->
          <!-- tabs 2 start -->
          <el-tab-pane label="授权给我的" name="overview">
            <contract-tab-left></contract-tab-left>
          </el-tab-pane>
          <!-- tabs 2 end -->
        </el-tabs>
      </div>
      <contarct-table
        v-show="tabsActive == 'overview'"
        class="right-wrap"
      ></contarct-table>
      <div class="right-wrap" v-show="tabsActive == 'contract'">
        <route-name
          :propsRouteName="computedCurrentMenuName"
          :style="{
            fontSize: '16px',
            lineHeight: '36px',
            backgroundColor: '#fff',
            paddingLeft: '16px',
            fontWeight: '600',
            borderBottom: 'solid 1px #E5E5E5',
          }"
        />
        <div id="nuxt-view">
          <nuxt-child
            :badge.sync="badge"
            ref="rightWrap"
            @batchLength="batchLength"
            @emitFn="emitFn"
          />
        </div>
        <el-button
          v-if="showDirBtn"
          :class="
            $route.fullPath.indexOf('applyList?match=-1') > -1
              ? 'outbox'
              : 'inbox'
          "
          style="position: absolute; top: 108px; z-index: 1000"
          size="small"
          @click="saveToDir"
          >归档</el-button
        >
        <!-- 收件箱归档列表里面添加归档(移动)和物理删除按钮 -->
        <template v-if="currentPathDirType === 2 && $route.query.directoryId">
          <div style="position: absolute; top: 15px; left: 15px; z-index: 1000">
            <!-- 新添加 -->
            <el-button @click="dirMove()" size="small">归档</el-button>
          </div>
        </template>
        <!--        里面-->
        <template
          v-if="currentPathDirType === 1 && $route.query.directoryId && false"
        >
          <div
            style="position: absolute; bottom: 15px; left: 15px; z-index: 1000"
          >
            <!-- 新添加 -->
            <el-button @click="dirMove()" size="small">归档</el-button>
            <el-button @click="removeFromDir()" size="small">删除</el-button>
          </div>
        </template>
        <!-- 草稿箱添加删除按钮 -->
        <template v-if="$route.query.signStatus == '4' && batch">
          <div
            style="position: absolute; top: 108px; left: 290px; z-index: 1000"
          >
            <!--            <el-button @click="deleteFromDir()" size="small">删除</el-button>-->
          </div>
        </template>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogFormVisible"
      :title="currentDir.directoryId ? '重命名归档文件夹' : '添加归档文件夹'"
      :close-on-click-modal="false"
      width="460px"
    >
      <el-row style="margin: 10px 20px">
        <el-col :span="3">
          <span style="vertical-align: middle">名称：</span>
        </el-col>
        <el-col :span="21">
          <el-input placeholder="请输入文件夹名称" v-model="currentDir.name" size="small" :maxlength="10" />
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="createOrUpdateDir()" size="small" type="danger"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="showAllDirs"
      class="dialog-height"
      title="选择归档文件夹"
      :close-on-click-modal="false"
      width="460px"
    >
      <ul class="move-to-dir">
        <!--归档文件夹-->
        <template v-if="currentPathDirType === 1">
          <li
            @click="chooseFolder(folder, index)"
            :class="{ active: choosenFolder.index === index }"
            v-for="(folder, index) in dirList"
            :key="'folder-' + index"
          >
            <span v-if="folder.nodeIcon" :class="folder.nodeIcon"></span>
            {{ folder.label }}
          </li>
        </template>

        <!--收件箱-->
        <template v-if="currentPathDirType === 2">
          <li
            @click="chooseFolder(folder, index)"
            :class="{ active: choosenFolder.index === index }"
            v-for="(folder, index) in receivedDirList"
            :key="'folder-' + index"
          >
            <span v-if="folder.nodeIcon" :class="folder.nodeIcon"></span>
            {{ folder.label }}
          </li>
        </template>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAllDirs = false" size="small">取消</el-button>
        <el-button @click="saveApplySignToDir()" size="small" type="danger"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 移动归档 -->
    <el-dialog
      :visible.sync="moveDirVisible"
      class="dialog-height"
      title="选择归档文件夹"
      :close-on-click-modal="false"
      width="460px"
    >
      <ul class="move-to-dir">
        <!--收件箱-->
        <li
          @click="chooseFolder(folder, index)"
          :class="{ active: choosenFolder.index === index }"
          v-for="(folder, index) in moveDirList"
          :key="'received-folder-' + index"
        >
          <span v-if="folder.nodeIcon" :class="folder.nodeIcon"></span>
          {{ folder.label }}
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button @click="moveDirVisible = false" size="small">取消</el-button>
        <el-button @click="moveApplySignToDir()" size="small" type="danger"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Bus from "@/plugins/bus.js";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
// 组件
import PublishSign from "@/components/publish-sign/sign";
import ApplyMenuTree from "@/components/apply-menu-tree";
import RouteName from "@/components/route-name";
import ChangeAccount from "@/components/change-account";
import RoleTab from "@/components/role-tab";
import contractTabLeft from "@/components/signInfo/contractTabLeft";
import contarctTable from "@/components/signInfo/contarctTable";
// 数据
import { gantConf } from "../../assets/js/utils/jurisdiction";
import { isInDingTalk } from "../../assets/js/utils/ding-env";
import { postSignCont as corp_postSignCont } from "../../assets/js/http-serve/corp/http-methods";

export default {
  data () {
    return {
      isInDingTalk,
      gantConf,
      tabsActive: "contract", // tabs 默认选择
      firstCreate: false, // 第一次创建
      moveDirResourceListSend: [], // 归档文件夹
      moveDirResourceListReceive: [], // 收件箱
      moveDirVisible: false,
      routePath: "",
      dirList: [],
      receivedDirList: [], // 收件箱归档
      moveDirList: [], // 移动归档
      dirType: -1, // 新增文件夹类型 1：归档文件夹 2：收件箱
      selectedApplys: [],
      choosenFolder: {},
      dialogFormVisible: false,
      showAllDirs: false,
      currentDir: {},
      badge: 0,
      currentMenuName: "", // 当前匹配的菜单名称，用于传递给routeName组件
      batch: null,
      corpSignCount: {
        signNum: 0,
        endNum: 0,
        apprveNum: 0,
      }
    };
  },
  mounted () {
    this.tabsActive = this.$route.query.tabType || "contract";
    this.getSearchCorpInfo(); //数量统计
    //专为 applyListNew 、signListNew组件使用（navTab切换的页面的 归档按钮）
    Bus.$on("$saveToDirNew", (obj) => {
      this.saveToDirNew(obj.selection);
    })
  },
  beforeDestroy () {
    Bus.$off("$saveToDirNew");
  },
  methods: {
    emitFn (fn) {
      this[fn]();
    },//获取数量统计
    getSearchCorpInfo () {
      // 查询父企业信息 { _ctToken: res.token }
      if (['/corp/signInfo/signList', '/corp/signInfo/sealApproval', '/signInfo/signList'].includes(this.$route.path)) {
        corp_postSignCont().then(result => {
          if (result && result.data) {
            this.$store.dispatch("actionSingCountAll", result.data);
            this.corpSignCount.signNum = this.signNumberFn([result.data.noFinishCount, result.data.myApplyNotSelfSignCount, result.data.ccToMeSignCount]);
            this.corpSignCount.endNum = this.signNumberFn([result.data.myFinishCount, result.data.ccToMeFinishCount]);
            this.corpSignCount.apprveNum = this.signNumberFn([result.data.approveCount, result.data.approveSignCount]);
          } else {
            !result && this.$message.error(result.description || this.$tip);
          }
        });
      }
    },
    //累加
    signNumberFn (arr) {
      return arr.reduce((prev, next) => {
        return prev + Number(next ? next : 0);
      }, 0)
    },
    batchLength (val) {
      this.batch = val;
    },
    // 草稿箱删除操作
    deleteFromDir () {
      let selection = [];
      try {
        selection = this.$refs["rightWrap"].$refs["dataList"].selection;
      } catch (e) {
        this.$message.error("无法获取选中的文件，请刷新重试");
        console.log(e);
      }
      if (selection.length === 0) {
        return this.$alert("请选择要删除的文件");
      }
      this.$confirm("该操作删除后的合同将无法恢复，确认删除？", "系统提示", {
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning",
        dangerouslyUseHTMLString: true
      })
        .then(async () => {
          let applySet = [];
          selection.forEach(apply => {
            applySet.push(apply.applyId);
          });
          let res = await ApiCorpMethods.DirectoryController.draftDel({
            applyIds: applySet.join(",")
          });
          if (res.success) {
            this.$message.success(res.description || "移除文件成功");
            this.$refs["rightWrap"].getSignLists();
          } else {
            this.$message.error(res.description || "移除文件失败");
          }
        })
        .catch(() => { });
    },
    // 重新封装 moveDirList
    reloadMoveDirList () {
      this.moveDirList = [];
      // 归档文件夹
      if (this.currentPathDirType === 1) {
        this.moveDirResourceListSend.forEach(element => {
          // if (element.id.indexOf(this.$route.query.directoryId) === -1) {
          //
          // }
          let v = JSON.parse(JSON.stringify(element));
          v.nodeIcon = "tree-icon tree-icon7";
          this.moveDirList.push(v);
        });
        // this.moveDirList.unshift({
        //   id: `/corp/signInfo/applyList?directoryId=-1`,
        //   label: "归档文件夹(未归档)",
        //   route: {
        //     path: "/corp/signInfo/applyList",
        //     query: {
        //       match: -1
        //     }
        //   },
        //   nodeIcon: "tree-icon tree-icon4"
        // });
      }
      // 收件箱
      if (this.currentPathDirType === 2) {
        this.moveDirResourceListReceive.forEach(element => {
          // if (element.id.indexOf(this.$route.query.directoryId) === -1) {
          //
          // }
          let v = JSON.parse(JSON.stringify(element));
          v.nodeIcon = "tree-icon tree-icon7";
          this.moveDirList.push(v);
        });
        this.moveDirList.unshift({
          id: `/corp/signInfo/signList?directoryId=-1`,
          label: "收件箱(未归档)",
          route: {
            path: "/corp/signInfo/signList",
            query: {
              match: -1
            }
          },
          nodeIcon: "tree-icon tree-icon3"
        });
      }
    },
    // 移动归档合同
    dirMove () {
      // 收件箱
      this.reloadMoveDirList();
      let selection = [];
      try {
        selection = this.$refs["rightWrap"].$refs["dataList"].selection;
      } catch (e) {
        this.$message.error("无法获取选中的文件，请刷新重试");
        console.log(e);
      }
      if (selection.length === 0) {
        return this.$alert("请选择归档文件");
      }
      this.selectedApplys = [];
      this.choosenFolder = {};
      selection.forEach(apply => {
        // 收集选中的所有合同
        this.selectedApplys.push(apply.directoryRelationId);
      });
      this.moveDirVisible = true;
    },
    async moveApplySignToDir () {
      if (!this.choosenFolder.index && this.choosenFolder.index !== 0) {
        return this.$message.error("请选择归档文件夹");
      }
      // 移除
      if (this.choosenFolder.index === 0 && false) {
        let param = {};
        param.directoryRelationIdSet = this.selectedApplys.join(",");
        param.directoryId = this.$route.query.directoryId;
        let res = await ApiCorpMethods.DirectoryController.removeApplySignFromDir(
          param
        );
        this.moveDirVisible = false;
        this.choosenFolder = {};
        if (res.success) {
          this.$message.success(res.description || "归档文件成功");
          // 清空右边表格的选中状态
          if (
            this.$refs["rightWrap"] &&
            this.$refs["rightWrap"].$refs["dataList"]
          ) {
            this.$refs["rightWrap"].$refs["dataList"].clearSelection();
            this.$refs["rightWrap"].getSignLists();
          }
        } else {
          this.$message.error(res.description || "归档文件失败");
        }
      } else {
        // 移动
        let param = {};
        param.directoryRelationIdSet = this.selectedApplys.join(",");
        param.directoryId = this.$route.query.directoryId;
        param.targetDirectoryId = this.choosenFolder.route.query.directoryId;
        let res = await ApiCorpMethods.DirectoryController.moveToTargetDir(
          param
        );
        this.moveDirVisible = false;
        this.choosenFolder = {};
        if (res.success) {
          this.$message.success(res.description || "归档文件成功");
          // 清空右边表格的选中状态
          if (
            this.$refs["rightWrap"] &&
            this.$refs["rightWrap"].$refs["dataList"]
          ) {
            this.$refs["rightWrap"].$refs["dataList"].clearSelection();
            this.$refs["rightWrap"].getSignLists();
          }
        } else {
          this.$message.error(res.description || "归档文件失败");
        }
      }
    },
    initMenuTree () {
      this.queryDirectory({ dirType: 1 });
      this.queryDirectory({ dirType: 2 });
    },
    // 查询归档文件夹列表
    async queryDirectory (opt) {
      let mergedOpt = opt || {};
      let param = {
        itemPage: 1,
        pageSize: 50,
        dirType: mergedOpt.dirType || -1
      };
      let res = await ApiCorpMethods.DirectoryController.listByPage(param);
      if (res.success && res.data) {
        if (mergedOpt.dirType === 1) {
          this.dirList = [];
          this.moveDirResourceListSend = [];
        } else if (mergedOpt.dirType === 2) {
          this.receivedDirList = [];
          this.moveDirResourceListReceive = [];
        }
        res.data.forEach(dir => {
          let dirObj = {
            id: `/corp/signInfo/applyList?directoryId=${dir.directoryId}`,
            label: dir.name,
            route: {
              path: "/corp/signInfo/applyList",
              query: {
                directoryId: dir.directoryId
              }
            },
            slotClass: "showWhenHover",
            slots: [
              {
                clickFunc: () => {
                  this.showDirDialog(dir);
                },
                iconClass: "el-icon-edit-outline",
                hoverTitle: "重命名"
              },
              {
                clickFunc: () => {
                  this.deleteDirectory(dir.directoryId, mergedOpt.dirType);
                },
                iconClass: "el-icon-delete",
                hoverTitle: "删除"
              }
            ],
            nodeIcon: "tree-icon tree-icon7"
          };
          let receiveObj = {
            id: `/corp/signInfo/signList?directoryId=${dir.directoryId}`,
            label: dir.name,
            route: {
              path: "/corp/signInfo/signList",
              query: {
                directoryId: dir.directoryId
              }
            },
            slotClass: "showWhenHover",
            slots: [
              {
                clickFunc: () => {
                  this.showDirDialog(dir);
                },
                iconClass: "el-icon-edit-outline",
                hoverTitle: "重命名"
              },
              {
                clickFunc: () => {
                  this.deleteDirectory(dir.directoryId, mergedOpt.dirType);
                },
                iconClass: "el-icon-delete",
                hoverTitle: "删除"
              }
            ],
            nodeIcon: "tree-icon tree-icon7"
          };

          if (mergedOpt.dirType === 1) {
            // 归档文件夹
            this.dirList.push(dirObj);
            this.moveDirResourceListSend.push(receiveObj);
            dirObj = null;
          } else if (mergedOpt.dirType === 2) {
            // 收件箱
            this.receivedDirList.push(receiveObj);
            this.moveDirResourceListReceive.push(receiveObj);
            receiveObj = null;
          }
        });

        // 调用树形菜单的resetTree方法
        this.$nextTick(() => {
          if (this.$refs.menuTree) {
            this.$refs.menuTree.resetTree();
          }
        });
      }
    },
    // 记录归档文件夹信息，并打开新增/修改窗口
    showDirDialog (dirObj) {
      if (dirObj !== undefined) {
        this.currentDir = JSON.parse(JSON.stringify(dirObj));
      } else {
        this.currentDir = {};
      }
      this.dialogFormVisible = true;
    },
    // 创建归档文件夹
    createOrUpdateDir () {
      if (!this.currentDir.name) return this.$message.error("请输入文件夹名称");
      if (this.currentDir.name.length > 10)
        return this.$message.error("文件夹名称不能超过10个字符");
      let param = this.currentDir;
      if (param.directoryId) {
        // 修改
        ApiCorpMethods.DirectoryController.update(param).then(result => {
          if (result.success) {
            this.dialogFormVisible = false;
            if (param.dirType === 1) {
              this.queryDirectory({ dirType: 1 });
            } else if (param.dirType === 2) {
              this.queryDirectory({ dirType: 2 });
            }
            this.$message.success(result.description || "操作成功");
          } else {
            this.$message.error(result.description || this.$tip);
          }
        });
      } else {
        // 判断是不是点击加号来的 -1: 不是  1、2：是
        if (this.dirType === -1) {
          // 通过计算属性，获取url对应的dirType
          param.dirType = this.currentPathDirType;
        } else {
          // 通过点击加号获取的dirType
          param.dirType = this.dirType;
          // 还原到点击前
          this.dirType = -1;
        }
        // 新增
        ApiCorpMethods.DirectoryController.create(param).then(result => {
          if (result.success) {
            this.dialogFormVisible = false;
            // 是否第一次添加
            if (this.firstCreate) {
              this.firstCreate = false;
              // 获取右边表格的选中状态
              if (
                this.$refs["rightWrap"] &&
                this.$refs["rightWrap"].$refs["dataList"]
              ) {
                let selection = this.$refs["rightWrap"].$refs["dataList"]
                  .selection;
                if (selection.length === 0) {
                  this.$alert("请选择归档文件");
                } else {
                  this.selectedApplys = [];
                  this.choosenFolder = {};
                  selection.forEach(apply => {
                    // 收集选中的所有合同
                    this.selectedApplys.push(apply.applyId);
                  });
                  this.showAllDirs = false;
                  // 保存合同
                  let saveParam = {};
                  saveParam.applyIdSet = this.selectedApplys.join(",");
                  saveParam.directoryId = result.data.directoryId;
                  ApiCorpMethods.DirectoryController.saveApplySignToDir(
                    saveParam
                  )
                    .then(res => {
                      if (res.success) {
                        this.$message.success(
                          res.description || "归档文件成功"
                        );
                        // 清空右边表格的选中状态
                        if (
                          this.$refs["rightWrap"] &&
                          this.$refs["rightWrap"].$refs["dataList"]
                        ) {
                          this.$refs["rightWrap"].$refs[
                            "dataList"
                          ].clearSelection();
                          this.$refs["rightWrap"].getSignLists();
                        }
                        // 正常流程
                        if (param.dirType === 1) {
                          this.$router.push({
                            path: "/corp/signInfo/applyList",
                            query: { directoryId: result.data.directoryId }
                          });
                          this.queryDirectory({ dirType: 1 });
                        } else if (param.dirType === 2) {
                          this.$router.push({
                            path: "/corp/signInfo/signList",
                            query: { directoryId: result.data.directoryId }
                          });
                          this.queryDirectory({ dirType: 2 });
                        }
                      } else {
                        this.$message.error(res.description || "归档文件失败");
                      }
                    })
                    .catch(() => { });
                }
              }
            } else {
              // 正常流程
              if (param.dirType === 1) {
                this.$router.push({
                  path: "/corp/signInfo/applyList",
                  query: { directoryId: result.data.directoryId }
                });
                this.queryDirectory({ dirType: 1 });
              } else if (param.dirType === 2) {
                this.$router.push({
                  path: "/corp/signInfo/signList",
                  query: { directoryId: result.data.directoryId }
                });
                this.queryDirectory({ dirType: 2 });
              }
              this.$message.success(result.description || "操作成功");
            }
          } else {
            this.$message.error(result.description || this.$tip);
          }
        });
      }
    },
    // 删除归档文件夹
    deleteDirectory (directoryId, dirType) {
      this.$confirm(
        '是否删除当前文件夹？',
        "系统提示",
        {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          let param = { directoryId: directoryId };
          ApiCorpMethods.DirectoryController.delete(param).then(result => {
            if (result.success) {
              if (parseInt(result.data) === 0) {
                this.$confirm(
                  '<p style="font-size: 16px;color: #000;">无法删除当前文件夹</p><p>请先将归档文件移至其他文件夹</p>',
                  "系统提示",
                  {
                    confirmButtonText: "知道了",
                    showCancelButton: false,
                    type: "warning",
                    dangerouslyUseHTMLString: true
                  }
                )
                  .then(() => { })
                  .catch(() => { });
                return;
              }
              if (dirType) {
                this.queryDirectory({ dirType });
                if (dirType === 1) {
                  this.$router.push({
                    path: "/corp/signInfo/applyList",
                    query: { directoryId: result.data.directoryId }
                  });
                } else if (dirType === 2) {
                  this.$router.push({
                    path: "/corp/signInfo/signList",
                    query: { directoryId: result.data.directoryId }
                  });
                }
              } else {
                this.queryDirectory({ dirType: 1 });
                this.queryDirectory({ dirType: 2 });
              }
              this.$message.success(result.description || "操作成功");
            } else {
              this.$alert(result.description || "删除文件夹失败", "系统提示");
            }
          });
        })
        .catch(() => { });
    },
    //给applyListNew 和signListNew这两个组件单独用的
    saveToDirNew (selection) {
      // let selection = this.$refs["rightWrap"].$refs["dataList"].selection;
      if (selection.length === 0) {
        this.$alert("请选择归档文件");
      } else {
        this.selectedApplys = [];
        this.choosenFolder = {};
        selection.forEach(apply => {
          this.selectedApplys.push(apply.applyId || apply.approval.applyId);
        });
        this.showAllDirs = true;
      }
    },
    // 临时存储归档文件的applyId
    saveToDir () {
      // 归档文件夹 归档
      this.firstCreate = false;
      if (this.currentPathDirType === 1 && this.dirList.length === 0) {
        this.firstCreate = true;
        return this.$alert("请先创建归档文件夹")
          .then(() => {
            this.dialogFormVisible = true;
          })
          .catch(() => { });
      }
      // 收件箱归档
      else if (
        this.currentPathDirType === 2 &&
        this.receivedDirList.length === 0
      ) {
        this.firstCreate = true;
        return this.$alert("请先创建归档文件夹")
          .then(() => {
            this.dialogFormVisible = true;
          })
          .catch(() => { });
      }
      if (
        this.$refs["rightWrap"] &&
        this.$refs["rightWrap"].$refs["dataList"]
      ) {
        let selection = this.$refs["rightWrap"].$refs["dataList"].selection;
        if (selection.length === 0) {
          this.$alert("请选择归档文件");
        } else {
          this.selectedApplys = [];
          this.choosenFolder = {};
          selection.forEach(apply => {
            this.selectedApplys.push(apply.applyId || apply.approval.applyId);
          });
          this.showAllDirs = true;
        }
      }
    },
    // 归档文件接口
    async saveApplySignToDir () {
      if (!this.choosenFolder.index && this.choosenFolder.index !== 0) {
        return this.$message.error("请选择归档文件夹");
      }
      let param = {};
      param.applyIdSet = this.selectedApplys.join(",");
      param.directoryId = this.choosenFolder.route.query.directoryId;
      let res = await ApiCorpMethods.DirectoryController.saveApplySignToDir(
        param
      );
      this.showAllDirs = false;
      this.choosenFolder = {};
      if (res.success) {
        this.$message.success(res.description || "归档文件成功");
        if (
          this.$refs["rightWrap"] &&
          this.$refs["rightWrap"].$refs["dataList"]
        ) {
          this.$refs["rightWrap"].$refs["dataList"].clearSelection();
          this.$refs["rightWrap"].getSignLists();
        } else {
          //清除applyListNew 、signListNew组件的操作
          Bus.$emit("$saveToDirNewEndClear")
        }
      } else {
        this.$message.error(res.description || "归档文件失败");
      }
    },
    // 归档文档 移除
    removeFromDir () {
      let selection = [];
      try {
        selection = this.$refs["rightWrap"].$refs["dataList"].selection;
      } catch (e) {
        this.$message.error("无法获取选中的文件，请刷新重试");
        console.log(e);
      }
      if (selection.length === 0) {
        return this.$alert("请选择要移除的文件");
      }
      this.$confirm(
        '<p style="font-size: 16px;color: #000;">是否移除文件?</p><p style="font-size: 12px;color: #949494;">移除后不会出现在当前归档文件夹中</p>',
        "系统提示",
        {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
          dangerouslyUseHTMLString: true
        }
      )
        .then(async () => {
          let applySet = [];
          selection.forEach(apply => {
            applySet.push(apply.directoryRelationId);
          });
          let res = await ApiCorpMethods.DirectoryController.removeApplySignFromDir(
            {
              directoryId: this.$route.query.directoryId,
              directoryRelationIdSet: applySet.join(",")
            }
          );
          if (res.success) {
            this.$message.success(res.description || "移除文件成功");
            this.$refs["rightWrap"].getSignLists();
          } else {
            this.$message.error(res.description || "移除文件失败");
          }
        })
        .catch(() => { });
    },
    chooseFolder (folder, index) {
      this.choosenFolder = Object.assign({}, folder);
      this.choosenFolder.index = index;
    }
  },
  computed: {
    // 获取权限数组菜单
    getPerms () {
      let perms = this.$store.getters.consoleToken;
      perms = perms ? perms.perms : [];
      return perms;
    },
    menus () {
      return [
        //   {
        //   id: '/corp/signInfo/signList?signStatus=2',
        //   label: '未完成',
        //   route: {
        //     path: '/corp/signInfo/signList',
        //     query: {signStatus: 2}
        //   },
        //   badge: this.badge,
        //   nodeIcon: 'tree-icon tree-icon1'
        // },
        {
          id: "/corp/signInfo/signList?signStatus=4",
          label: "待签的",
          route: {
            path: "/corp/signInfo/signList",
            query: { signStatus: 4 }
          },
          badge: this.corpSignCount.signNum,
          nodeIcon: "tree-icon tree-icon1"
        },
        // {
        //   id: "/corp/signInfo/signList?signStatus=5",
        //   label: "待审批",
        //   route: {
        //     path: "/corp/signInfo/signList",
        //     query: { signStatus: 5 }
        //   },
        //   badge: this.badge,
        //   nodeIcon: "tree-icon tree-icon10"
        // },
        {
          id: "/corp/signInfo/signList?signStatus=5",
          label: "待审批",
          routeName: "待审批",
          route: {
            path: "/corp/signInfo/signList",
            query: { signStatus: 5 }
          },
          badge: this.corpSignCount.apprveNum,//this.badge,
          // slotClass: "showWhenHover",
          // children: [
          //   {
          //     id: "/corp/signInfo/signList?signStatus=5",
          //     label: "文件审批",
          //     routeName: "文件审批",
          //     route: {
          //       path: "/corp/signInfo/signList",
          //       query: { signStatus: 5 }
          //     },
          //     badge: (+this.badge || 0),
          //     slotClass: "showWhenHover",
          //     nodeIcon: "tree-icon tree-icon10"
          //   },
          //   {
          //     id: "/corp/signInfo/sealApproval?signStatus=6",
          //     label: "用印审批",
          //     routeName: "用印审批",
          //     route: {
          //       path: "/corp/signInfo/sealApproval",
          //       query: { signStatus: 6 }
          //     },
          //     badge: this.badge,
          //     slotClass: "showWhenHover",
          //     nodeIcon: "tree-icon tree-icon10",
          //     show: isInDingTalk
          //   }
          // ],
          nodeIcon: "tree-icon tree-icon10"
        },
        {
          id: "/corp/signInfo/signList?signStatus=3",
          label: "已结束",
          route: {
            path: "/corp/signInfo/signList",
            query: { signStatus: 3 }
          },
          badge: (+this.badge) + (+this.corpSignCount.endNum),
          nodeIcon: "tree-icon tree-icon2",
          slotClass: ""
        },
        {
          id: "/corp/signInfo/applyList?signStatus=4",
          label: "草稿箱",
          route: {
            path: "/corp/signInfo/applyList",
            query: { signStatus: 4 }
          },
          badge: this.badge,
          nodeIcon: "tree-icon tree-icon5",
          slotClass: "separated"
        },
        // {
        //   id: "/corp/signInfo/signList?ccToMe=1&signStatus=1",
        //   label: "抄送给我的",
        //   routeName: "抄送给我的",
        //   route: {
        //     path: "/corp/signInfo/signList",
        //     query: { ccToMe: 1, signStatus: 1 }
        //   },
        //   badge: this.badge,
        //   slotClass: "showWhenHover",
        //   slots: [],
        //   nodeIcon: "tree-icon tree-icon4"
        // },
        // {
        //   label: "我发给他人的",
        //   id: "/corp/signInfo/applyList?notMeSign=1",
        //   route: {
        //     path: "/corp/signInfo/applyList",
        //     query: { notMeSign: 1 }
        //   },
        //   badge: this.badge,
        //   nodeIcon: "tree-icon tree-icon1",
        //   slotClass: "separated"
        // },
        {
          id: "/corp/signInfo/applyList?match=-1",
          label: "归档文件夹",
          routeName: "归档文件夹（未归档）",
          route: {
            path: "/corp/signInfo/applyList",
            query: { match: -1 }
          },
          badge: this.badge,
          // slotClass: "showWhenHover",
          slotClass: "separated",
          slots: [
            {
              clickFunc: () => {
                this.dirType = 1;
                this.showDirDialog();
              },
              iconClass: "el-icon-folder-add",
              hoverTitle: "添加归档文件夹"
            }
          ],
          children: this.dirList,
          nodeIcon: "tree-icon tree-icon3"
        },
        this.changeAccount
      ];
    },
    changeAccount () {
      // try{
      //   if(this.$store.getters.allAuthUser.bindCorpUsers.length > 0){
      //     return {
      //       id: 'changeUserInfo',
      //       label: '切换签署主体',
      //       children: [
      //         {
      //           id: 'searchUserInfo',
      //           component: {
      //             template: ChangeAccount,
      //             class: {
      //               marginLeft: '-25px'
      //             }
      //           },
      //         }
      //       ],
      //       nodeIcon: 'tree-icon tree-icon9'
      //     }
      //   }
      //   return {}
      // }catch (e) {
      //   return {}
      // }
      // 改版后，不渲染 “切换签署主体”
      return {};
    },
    showDirBtn () {
      let path = this.$route.fullPath;
      let showBtnRoutes = [
        "/corp/signInfo/signList?match=-1",
        "/corp/signInfo/applyList?match=-1"
      ];
      for (let i = 0, length = showBtnRoutes.length; i < length; i++) {
        if (path.indexOf(showBtnRoutes[i]) != -1 && this.batch) {
          return true;
        }
      }
      return false;
    },
    currentPathDirType () {
      if (this.$route.path === "/corp/signInfo/signList") {
        // 当前路由是收件箱
        // return 2;
        return 1;
      } else if (this.$route.path === "/corp/signInfo/applyList") {
        // 当前路由是归档文件夹
        // return this.$route.query.notMeSign ? 2 : 1;
        return 1;
      }
      return -1;
    },
    computedCurrentMenuName () {
      return this.currentMenuName;
    }
  },
  watch: {
    $route: {
      handler ({ path }) {
        this.routePath = path;
      },
      deep: true
    },
    dialogFormVisible: {
      handler (val) {
        if (val === false) {
          this.currentDir = {};
        }
      }
    }
  },
  asyncData ({ route }) {
    return { routePath: route.path };
  },
  layout (context) {
    if (
      context.route.path.indexOf("toDetailAnony") !== -1 ||
      context.route.path.indexOf("viewDetail") !== -1
    ) {
      return "fullpage";
    } else {
      return "default";
    }
  },
  head: { title: "文件管理" },
  name: "signInfo",
  components: {
    PublishSign,
    ApplyMenuTree,
    RouteName,
    RoleTab,
    contractTabLeft,
    contarctTable
  }
};
</script>

<style lang="less" scoped>
@import (less) "../../assets/style/icon.css";
.tabs-style /depp/ .el-tabs__item {
  :hover {
    color: #ec1c1c;
  }
  .is-active {
    color: #ec1c1c;
  }
}
.tabs-style /depp/ .el-tabs__active-bar {
  background-color: #ec1c1c;
}
.main-wrap {
  /*height: calc(100vh - 125px - 80px);*/
  display: flex;
  justify-content: space-between;
  .left-wrap {
    /*height: 100%;*/
    padding: 0 0 15px;
    /*float: left;*/
    width: 230px;
    background-color: #ffffff;
    overflow: auto;
    .dindin_code {
      padding-top: 10px;
      text-align: center;
      .code_img {
        width: 180px;
        height: 180px;
      }
    }
    /deep/ .publish {
      padding: 15px 0;
      text-align: left;
      border-bottom: solid 1px #e5e5e5;
      .upload-file {
        width: 80%;
        margin-left: 10%;
        input[type="file"] {
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
        }
        .el-button {
          width: 100%;
        }
      }
      .tpl {
        width: 80%;
        margin-left: 10%;
        margin-bottom: 0;
      }
    }
  }
  .right-wrap {
    min-height: 75vh;
    flex-grow: 1;
    max-width: calc(100% - 235px);
    margin-left: 5px;
    position: relative;
    background-color: #ffffff;
    .table-wrap {
      padding: 0 16px;
    }
    .inbox {
      left: 305px;
    }
    .outbox {
      left: 240px;
    }
    /deep/ .row {
      padding: 15px;
      height: 62px;
      min-height: 62px;
    }
    /deep/ .data-list {
      /*height: calc(100vh - 296px - 70px);*/
      width: inherit;
      margin: 0 15px;
      border: 1px solid #eeeeee;
    }
    /deep/ .el-table__body-wrapper {
      /*height: calc(100% - 48px);*/
      /*overflow-y: auto;*/
    }
    #nuxt-view /deep/ .go-style {
      top: 18px;
    }
    /deep/ .pageation {
      position: relative;
    }
    // /deep/ .el-button {
    //   background: rgba(236, 28, 28, 1);
    //   color: #ffffff;

    //   &:hover {
    //     opacity: 0.7;
    //   }
    // }
  }
}
/deep/.menu-tree {
  .tree-icon {
    display: inline-block;
    width: 15px;
    height: 15px;
    vertical-align: middle;
    margin-right: 5px;
    background-image: url("/images/icon/tree-icon.png");
    background-repeat: no-repeat;
    background-size: cover;
    &.tree-icon1 {
      background-image: url("/images/file-weiwancheng.png");
      background-size: cover;
    }
    &.tree-icon2 {
      background-image: url("/images/file-jieshu.png");
      background-size: cover;
    }
    &.tree-icon3 {
      background-image: url("/images/shoujian.png");
      background-size: cover;
    }
    &.tree-icon4 {
      background-image: url("/images/fasong.png");
      background-size: cover;
    }
    &.tree-icon5 {
      background-image: url("/images/file-caogaoxiang.png");
      background-size: cover;
    }
    &.tree-icon6 {
      background-image: url("/images/weiquan.png");
      background-position: 0;
      background-size: cover;
    }
    &.tree-icon7 {
      background-image: url("/images/wenjianjia.png");
      background-position: 0;
      background-size: cover;
    }
    &.tree-icon8 {
      background-position: 0 0 !important;
      background-size: 500% 500% !important;
    }
    &.tree-icon9 {
      background-image: url("/images/qiehuan.png");
      background-size: 16px;
      background-position: 4px 2px;
    }
    &.tree-icon10 {
      .icon-tree10();
    }
  }
  .is-checked > .el-tree-node__content {
    .tree-icon.tree-icon1 {
      background-image: url("/images/file-weiwanchengHover.png");
      background-size: cover;
    }
    .tree-icon.tree-icon2 {
      background-image: url("/images/file-jieshuHover.png");
      background-size: cover;
    }
    .tree-icon.tree-icon3 {
      background-image: url("/images/shoujianHover.png");
      background-size: cover;
    }
    .tree-icon.tree-icon4 {
      background-image: url("/images/fasongHover.png");
      background-size: cover;
    }
    .tree-icon.tree-icon5 {
      background-image: url("/images/file-caogaoxiangHover.png");
      background-size: cover;
    }
    .tree-icon.tree-icon6 {
      background-image: url("/images/weiquan.png");
      background-size: cover;
    }
    .tree-icon.tree-icon7 {
      background-image: url("/images/wenjianjia.png");
      background-position: 0;
      background-size: cover;
    }
    .tree-icon.tree-icon8 {
      background-position: 0 0 !important;
      background-size: 500% 500% !important;
    }
    .tree-icon.tree-icon10 {
      .icon-tree10-on();
    }
  }
}
nav.menu {
  overflow: hidden;
  margin-top: 10px;
  .nav-bar {
    width: 100%;
    .nav-item {
      font-size: 15px;
      color: #666666;
      margin-right: 40px;
    }
    .nav-item:before {
      content: "";
      display: inline-block;
      width: 2px;
      height: 18px;
      background: #ffffff;
      vertical-align: middle;
      margin-right: 6px;
    }
    .nav-item.active:before {
      background: #ec1c1c;
    }
    .nav-item.active {
      color: #ec1c1c;
      .span {
        color: #ec1c1c;
      }
    }
  }
}
.save-to-dir {
  margin-right: 36%;
  li {
    padding: 6px 11px;
    cursor: pointer;
    border-radius: 4px;
    &:before {
      content: "";
      display: inline-block;
      width: 24px;
      height: 19px;
      margin-right: 5px;
      background-image: url("/images/icon/icon-folder.png");
      background-size: 100%;
      background-repeat: no-repeat;
      vertical-align: top;
      opacity: 0.6;
    }
    &:hover {
      background-color: #f1f1f1;
    }
    &.active {
      background-color: #f1f1f1;
    }
  }
}

.move-to-dir {
  li {
    padding: 6px 11px;
    cursor: pointer;
    border-radius: 4px;
    &:hover {
      background-color: #f1f1f1;
    }
    &.active {
      background-color: #f1f1f1;
    }
  }
  .tree-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    margin-right: 5px;
    background-image: url("/images/icon/tree-icon.png");
    background-repeat: no-repeat;
    background-size: 500% 500%;
    background-position: 0 -60px;
    &.tree-icon1 {
      background-image: url("/images/file-weiwancheng.png");
      background-size: 37px;
      background-position: -8px -8px;
    }
    &.tree-icon2 {
      background-image: url("/images/file-jieshu.png");
      background-size: 37px;
      background-position: -8px -8px;
    }
    &.tree-icon3 {
      background-image: url("/images/shoujian.png");
      background-position: 0;
      background-size: cover;
    }
    &.tree-icon4 {
      background-image: url("/images/fasong.png");
      background-position: 0;
      background-size: cover;
    }
    &.tree-icon5 {
      background-image: url("/images/file-caogaoxiang.png");
      background-size: 37px;
      background-position: -8px -8px;
    }
    &.tree-icon6 {
      background-image: url("/images/weiquan.png");
      background-position: 0;
      background-size: cover;
    }
    &.tree-icon7 {
      background-image: url("/images/wenjianjia.png");
      background-position: 0;
      background-size: cover;
    }
    &.tree-icon8 {
      background-position: 0 0;
    }
    &.tree-icon9 {
      background-image: url("/images/qiehuan.png");
      background-size: 16px;
      background-position: 4px 2px;
    }
  }
}

/deep/.dialog-height {
  & > .el-dialog {
    .el-dialog__header {
      position: relative;
      background-color: transparent;
      padding: 4px 16px;
      .el-dialog__title {
        font-size: 16px;
        font-weight: 600;
      }
      .el-dialog__headerbtn {
        top: 0;
        bottom: 0;
        margin: auto 0;
      }
      .el-dialog__headerbtn:hover .el-dialog__close {
        color: #ec1c1c;
      }
    }
    .el-dialog__body {
      max-height: 60vh;
      overflow-y: auto;
      padding: 18px;
      border-top: solid 1px #e5e5e5;
      border-bottom: solid 1px #e5e5e5;
    }
    .el-dialog__footer {
      padding: 11px 14px;
      .el-button {
        padding: 7px 25px;
      }
    }
  }
}
/deep/.change-account {
  .photo {
    width: 24px;
    height: 24px;
  }
  .current-user {
    .el-icon-check {
      font-size: 18px;
    }
  }
}
/deep/ .el-tree-node__content {
  height: auto !important;
}
</style>

<style lang="less">
nav.nav-bar {
  .el-badge__content.is-fixed {
    right: 0;
  }
}
.el-tabs--bottom .el-tabs__header.is-bottom {
  margin-top: 0;
}
.el-tabs__item {
  font-weight: bold;
  font-size: 15px;
  padding: 0 12px !important;
}
.el-tabs__active-bar {
  /*display: none;*/
  color: #ec1c1c;
  background-color: #ec1c1c;
}
.el-tabs__item.is-active {
  color: #ec1c1c;
}
.el-tabs__item:hover {
  color: #ec1c1c;
}
.el-tabs__nav-wrap::after {
  height: 1px;
}
</style>



// WEBPACK FOOTER //
// pages/corp/signInfo.vue